<div class="felx flex-col justify-start items-stretch">
  <div fxLayout="row" fxLayoutAlign="end center" class="pb-2">
    <mat-button-toggle-group #group="matButtonToggleGroup">
      <mat-button-toggle value="table">
        <mat-icon>grid_on</mat-icon>
      </mat-button-toggle>
      <mat-button-toggle value="calendar">
        <mat-icon>today</mat-icon>
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <ag-grid-angular *ngIf="group.value === 'table'" #agGrid class="ag-theme-alpine" style="height: 500px;"
    [gridOptions]="gridOptions"></ag-grid-angular>
  <div *ngIf="group.value === 'calendar'">
    <div *ngIf="calendarItems.length; else noBookings">
      <div fxLayout="row" class="mt-3 mb-3">
        <div fxFlex="35">
          <button mat-icon-button (click)="changeViewDate(-1)">
            <mat-icon>navigate_before</mat-icon>
          </button>
          <button (click)="changeViewDate(0)" mat-button>Today</button>
          <button (click)="changeViewDate(1)" mat-icon-button>
            <mat-icon>navigate_next</mat-icon>
          </button>
        </div>
        <div fxFlex="30">
          <h3 *ngIf="calendarViewType === 'week'" class="text-center">
            Week {{ calendarViewDateMoment.format('w') }}
          </h3>
          <h3 *ngIf="calendarViewType === 'month'" class="text-center">
            {{ calendarViewDateMoment.format('MMMM') }}
          </h3>
          <h3 *ngIf="calendarViewType === 'day'" class="text-center">
            {{ calendarViewDateMoment.format('ddd D MMM YY') }}
          </h3>
        </div>
        <div fxFlex="35" fxLayout="row" fxLayoutAlign="end center">
          <button mat-button (click)="changeCalendarView('month')">Month</button>
          <button mat-button (click)="changeCalendarView('week')">Week</button>
          <button mat-button (click)="changeCalendarView('day')">Day</button>
        </div>
      </div>
      <div [ngSwitch]="calendarViewType">
        <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="calendarViewDate" [events]="calendarItems"
          [refresh]="refresh" [activeDayIsOpen]="false" (dayClicked)="bookingClicked($event)"
          (eventClicked)="bookingClicked($event)">
        </mwl-calendar-month-view>
        <mwl-calendar-week-view *ngSwitchCase="'week'" [viewDate]="calendarViewDate" [events]="calendarItems"
          [refresh]="refresh" [dayEndHour]="18" [dayStartHour]="7" (eventClicked)="bookingClicked($event)">
        </mwl-calendar-week-view>
        <mwl-calendar-day-view *ngSwitchCase="'day'" [viewDate]="calendarViewDate" [events]="calendarItems"
          [refresh]="refresh" (eventClicked)="bookingClicked($event)">
        </mwl-calendar-day-view>
      </div>
    </div>
    <ng-template #noBookings>
      <div fxLayout="row" fxLayoutAlign="center center">
        <p>No bookings to show.</p>
      </div>
    </ng-template>
  </div>
</div>